import React,{ forwardRef, ReactNode } from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface BlockHeaderProps {
    children: ReactNode;
    height?: string | number;
    sx?: SxProps<Theme>;
}

export const BlockHeader = forwardRef<HTMLDivElement, BlockHeaderProps>(
    ({ children, height, sx }, ref) => {
        return (
            <Box
                ref={ref}
                className="block-header"
                sx={{
                    height,
                    ...sx,
                }}
            >
                {children}
            </Box>
        );
    }
);

BlockHeader.displayName = 'BlockHeader';
